<div>
  @if (webUrl) {
    <iframe #webPageIframe [src]="webUrl"></iframe>
  }
</div>
